import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import type { paths } from 'user-api/src/generated/openApi/schema'
import { userApiClient } from '@/setup/api'

export type IGetUniversitiesQueryParams = NonNullable<
    paths['/web/universities']['get']['parameters']['query']
>

export const getUniversitiesQueryOptions = (
    params: IGetUniversitiesQueryParams,
    locale: string,
    options?: { enabled?: boolean }
) =>
    userApiClient.queryOptions(
        'get',
        '/web/universities',
        {
            params: { query: { q: params.q, country: params.country, limit: params.limit } },
            headers: { 'accept-language': locale },
        },
        {
            enabled: options?.enabled,
            // Keep the previous results visible while the next search is in flight so
            // the dropdown doesn't flicker empty on every keystroke.
            placeholderData: (previous) => previous,
        }
    )

export function useGetUniversitiesQuery(
    params: IGetUniversitiesQueryParams,
    options?: { enabled?: boolean }
) {
    const locale = useLocale()

    return useQuery(getUniversitiesQueryOptions(params, locale, options))
}
